var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.success)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n        "+_vm._s(_vm.success)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.danger)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n        "+_vm._s(_vm.danger)+"\n    ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ed16a31","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = ByiH
// module chunks = 1